import { Helmet } from "react-helmet-async";
import bowls from "../../../media/diet/bowls.png";
import greens from "../../../media/diet/greens.png";
import sprouts from "../../../media/diet/sprouts.png";
import lentils from "../../../media/diet/lentils.png";

const HighFiberDiet = () => {
  return (
    <div className="bg-skin py-16 px-[6%] md:px-[8%] font-montserrat">
      <Helmet>
        <title>High Fiber Diet | Kaumudi Somnay MD</title>
        <meta
          name="description"
          content="Dr. Somnay's High Fiber Diet guide: recommended fiber-rich foods, breakfast tips, and foods to avoid."
        />
        <link rel="canonical" href="/high-fiber-diet" />
      </Helmet>

      <h1 className="text-brown text-4xl md:text-5xl font-medium text-center mb-12">
        Dr. Somnay&rsquo;s High Fiber Diet
      </h1>

      <div className="max-w-5xl mx-auto bg-white border border-gray-200 shadow-sm p-8 md:p-14">
        <p className="text-gry leading-relaxed mb-10">
          Dietary fiber is the part of a plant which is not digested by the
          stomach or small intestine. Rather, it arrives unchanged in the
          colon. It provides bulk or roughage and thereby helps promote
          regularity. More importantly, fibers are a nourishment source for
          the myriad numbers of bacteria that normally reside in the colon.
        </p>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-10">
          {/* Left column */}
          <div className="text-lg">
            <p className="text-gry font-semibold mb-2">
              Four main foods that include fiber are:
            </p>
            <ol className="list-decimal list-inside text-gry space-y-1 mb-8">
              <li>Oatmeal</li>
              <li>Green Leafy Vegetables</li>
              <li>Fruits</li>
              <li>Vegetable Proteins</li>
            </ol>

            <h2 className="text-brown font-semibold underline mb-2">
              Breakfast
            </h2>
            <p className="text-gry mb-8">
              Cook oatmeal with milk of choice and fruits below.
            </p>

            <h2 className="text-brown font-semibold mb-2">
              <span className="underline">Green Leafy Vegetables</span>: Cook
              as soup or saut&eacute;
            </h2>
            <ul className="text-gry space-y-1 mb-8">
              <li>Kale</li>
              <li>Spinach</li>
              <li>Broccoli</li>
              <li>Okra</li>
              <li>Green string beans</li>
            </ul>

            <h2 className="text-brown font-semibold underline mb-2">
              Fruits
            </h2>
            <ul className="text-gry space-y-1 mb-8">
              <li>Pears</li>
              <li>Apples</li>
              <li>Papayas</li>
              <li>Blueberries</li>
              <li>Strawberries</li>
            </ul>

            <h2 className="text-brown font-semibold underline mb-2">
              Vegetable Proteins
            </h2>
            <p className="text-gry mb-2">Soak overnight, cook as soup</p>
            <ul className="text-gry space-y-1">
              <li>Sprouted Mung Beans</li>
              <li>Lentils</li>
              <li>Edamame Beans</li>
              <li>Tofu</li>
            </ul>
          </div>

          {/* Right column */}
          <div>
            <div className="border-2 border-red-600 p-5 mb-8 max-w-xs">
              <p className="text-red-600 font-bold tracking-wide mb-3">
                ***AVOID***
              </p>
              <ul className="text-gry space-y-1">
                <li className="underline">Meats</li>
                <li className="underline">Sweets</li>
                <li className="underline">Fried foods</li>
                <li className="underline">White Breads</li>
                <li className="underline">Eggs</li>
              </ul>
            </div>

            <div className="space-y-4">
              <img
                src={bowls}
                alt="Bowls of fiber-rich grains and legumes"
                className="w-full max-w-md"
              />
              <img
                src={greens}
                alt="Green leafy vegetables, beans, avocado and raspberries"
                className="w-full max-w-md"
              />
              <img
                src={sprouts}
                alt="Sprouted mung beans"
                className="w-full max-w-md"
              />
              <img
                src={lentils}
                alt="Assorted lentils"
                className="w-full max-w-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HighFiberDiet;
